module.exports = __webpack_public_path__ + "media/day/113-0a6004fd.svg";